<section #storySection
  class="benin-story"
  [style.background-image]="'url(' + backgroundImage + ')'"
  >
  <div class="benin-story__overlay"></div>

  <article class="benin-story__card">
    <h2>{{ title }}</h2>
    <p class="benin-story__eyebrow">{{ eyebrow }}</p>

    <div class="benin-story__copy">
      @for (paragraph of paragraphs; track paragraph) {
        <p>{{ paragraph }}</p>
      }
    </div>
  </article>
</section>
